import { ChevronDown } from "lucide-react";
import React from "react";
import { ResponsiveLanguagePicker } from "../../language/ResponsiveLanguagePicker";

interface LanguageDropdownProps {
  selectedLanguage: string;
  selectedLanguageCode: string;
  setSelectedLanguageCode: (code: string) => void;
  languages: Record<string, string>;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  languageSearchTerm: string;
  setLanguageSearchTerm: (term: string) => void;
}

const LanguageDropdown: React.FC<LanguageDropdownProps> = ({
  selectedLanguage,
  selectedLanguageCode,
  setSelectedLanguageCode,
  languages,
  isOpen,
  setIsOpen,
  languageSearchTerm,
  setLanguageSearchTerm,
}) => (
  <ResponsiveLanguagePicker
    open={isOpen}
    onOpenChange={setIsOpen}
    trigger={
      <button
        type="button"
        className="flex min-h-11 items-center gap-2 rounded-lg border border-white/10 bg-[#1B1C22] px-3 text-sm font-medium text-white transition-colors hover:border-white/20 hover:bg-white/10"
        aria-expanded={isOpen}
      >
        <span>{selectedLanguage}</span>
        <ChevronDown
          className={`h-4 w-4 text-white/55 transition-transform motion-reduce:transition-none ${isOpen ? "rotate-180" : ""}`}
          aria-hidden="true"
        />
      </button>
    }
    languages={languages}
    selectedLanguageCode={selectedLanguageCode}
    onSelectLanguage={setSelectedLanguageCode}
    searchTerm={languageSearchTerm}
    onSearchTermChange={setLanguageSearchTerm}
    title="Choose an exercise language"
  />
);

export default LanguageDropdown;
